import React from "react";

import close from "./../../../UI/general/close.svg";
import gallery from "./../../../UI/Modal/gallery.svg";
import collapsed from "./../../../UI/general/collapse.svg";

import next from "./../../../UI/general/Next-Asset.svg";
import next_b from "./../../../UI/general/Next.svg";
import back_b from "./../../../UI/general/Previus.svg";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import ThreeScene from "./ThreeScene";

// En algún lugar de tu código, por ejemplo, antes de tus componentes

interface Props {
  galleryData: any;
  colorsData: any;
  isGallery: boolean;
  handleGalleriesSelection: any;
  handleCloseGalleryModal: any;
  breadCrumbSelected: number;
  handleChangeBreadCrumbSelected: any;
}

interface State {
  isCollapsed: boolean;
  rgbaColor: any;
  galleryItemSelected: string;
  galleryIndexSelected: number;
  galleryIndexSelectedSub: number;
  galleryIndexGroupSelected: number;
  galleryIndexFolderSelected: number;
  galleryIndexFileSelected: number;
  selectedFile: string;
  breadCrumbs: any;
  SelectedGallery: boolean;
  show: boolean;
}

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

declare const window: any;
class GalleryModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isCollapsed: true,
      rgbaColor: "",
      galleryItemSelected: "",
      galleryIndexSelected: -1,
      galleryIndexSelectedSub: -1,
      galleryIndexGroupSelected: -1,
      galleryIndexFolderSelected: -1,
      galleryIndexFileSelected: -1,
      selectedFile: "",
      SelectedGallery: false,
      breadCrumbs: [],
      show: false,
    };
  }

  componentDidMount(): void {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(
      this.props.colorsData.main_buttons
    );
    this.setState({
      rgbaColor: result
        ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16),
          }
        : "",
    });
    if (this.state.isCollapsed) {
      setTimeout(() => {
        this.setState(
          {
            isCollapsed: false,
          },
          () => {}
        );
      }, 500);
    }
    setTimeout(() => {
      this.setState({
        show: true,
      });
    }, 100);
  }

  componentDidUpdate(
    prevProps: Readonly<Props>,
    prevState: Readonly<State>,
    snapshot?: any
  ): void {
    const elemento: any = document.querySelector(".a-canvas");
    if (elemento !== null) {
      elemento.style.setProperty('position', 'relative', 'important')
    }
    //console.log("aqui");
    //console.log(elemento);

    if (prevProps.breadCrumbSelected !== this.props.breadCrumbSelected) {
      if (this.props.breadCrumbSelected === -1) {
        this.setState({
          galleryItemSelected: "",
          galleryIndexSelected: -1,
          breadCrumbs: ["Galería"],
        });
      }
      /*if(this.props.breadCrumbSelected === 0){
                this.setState({
                    galleryIndexSelected: -1,
                }, () => {
                    this.setState({
                        galleryIndexSelected: 0
                    })
                })
            }*/
    }
    if (prevProps.isGallery !== this.props.isGallery && this.props.isGallery) {
      setTimeout(() => {
        this.setState({
          isCollapsed: !this.props.isGallery,
        });
      }, 300);
    } else if (
      prevProps.isGallery !== this.props.isGallery &&
      this.props.isGallery !== false
    ) {
      this.setState({
        galleryItemSelected: "",
        galleryIndexSelected: -1,
        breadCrumbs: ["Galería"],
      });
    }
  }

  handleNextGallery = () => {
    if (
      this.state.galleryIndexSelected !== -1 &&
      this.state.galleryIndexSelectedSub === -1
    ) {
      if (
        this.props.galleryData[this.state.galleryIndexGroupSelected]?.galleries
          ?.galleries[0][this.state.galleryIndexFolderSelected]?.links[
          this.state.galleryIndexFileSelected + 1
        ] !== undefined
      ) {
        this.setState({
          galleryIndexFileSelected: this.state.galleryIndexFileSelected + 1,
          selectedFile:
            this.props.galleryData[this.state.galleryIndexGroupSelected]
              ?.galleries?.galleries[0][this.state.galleryIndexFolderSelected]
              ?.links[this.state.galleryIndexFileSelected + 1].link,
        });
      } else {
        if (
          this.props.galleryData[this.state.galleryIndexGroupSelected]
            ?.galleries?.galleries[0][
            this.state.galleryIndexFolderSelected + 1
          ] !== undefined
        ) {
          this.setState({
            galleryIndexFileSelected: 0,
            galleryIndexFolderSelected:
              this.state.galleryIndexFolderSelected + 1,
            selectedFile:
              this.props.galleryData[this.state.galleryIndexGroupSelected]
                ?.galleries?.galleries[0][
                this.state.galleryIndexFolderSelected + 1
              ]?.links[0].link,
          });
        } else {
          this.setState({
            galleryIndexFileSelected: 0,
            galleryIndexFolderSelected: 0,
            galleryIndexGroupSelected: this.state.galleryIndexSelected,
            selectedFile:
              this.props.galleryData[this.state.galleryIndexSelected]?.galleries
                ?.galleries[0][0]?.links[0].link,
          });
        }
      }
    } else if (this.state.galleryIndexSelectedSub !== -1) {
      if (
        this.props.galleryData[this.state.galleryIndexGroupSelected]?.galleries
          ?.galleries[0][this.state.galleryIndexFolderSelected]?.links[
          this.state.galleryIndexFileSelected + 1
        ] !== undefined
      ) {
        this.setState({
          galleryIndexFileSelected: this.state.galleryIndexFileSelected + 1,
          selectedFile:
            this.props.galleryData[this.state.galleryIndexGroupSelected]
              ?.galleries?.galleries[0][this.state.galleryIndexFolderSelected]
              ?.links[this.state.galleryIndexFileSelected + 1].link,
        });
      } else {
        this.setState({
          galleryIndexFileSelected: 0,
          galleryIndexGroupSelected: this.state.galleryIndexSelected,
          selectedFile:
            this.props.galleryData[this.state.galleryIndexSelected]?.galleries
              ?.galleries[0][this.state.galleryIndexSelected]?.links[0].link,
        });
      }
    } else {
      if (
        this.props.galleryData[this.state.galleryIndexGroupSelected]?.galleries
          ?.galleries[0][this.state.galleryIndexFolderSelected]?.links[
          this.state.galleryIndexFileSelected + 1
        ] !== undefined
      ) {
        this.setState({
          galleryIndexFileSelected: this.state.galleryIndexFileSelected + 1,
          selectedFile:
            this.props.galleryData[this.state.galleryIndexGroupSelected]
              ?.galleries?.galleries[0][this.state.galleryIndexFolderSelected]
              ?.links[this.state.galleryIndexFileSelected + 1].link,
        });
      } else {
        if (
          this.props.galleryData[this.state.galleryIndexGroupSelected]
            ?.galleries?.galleries[0][
            this.state.galleryIndexFolderSelected + 1
          ] !== undefined
        ) {
          this.setState({
            galleryIndexFileSelected: 0,
            galleryIndexFolderSelected:
              this.state.galleryIndexFolderSelected + 1,
            selectedFile:
              this.props.galleryData[this.state.galleryIndexGroupSelected]
                ?.galleries?.galleries[0][
                this.state.galleryIndexFolderSelected + 1
              ]?.links[0].link,
          });
        } else {
          if (
            this.props.galleryData[this.state.galleryIndexGroupSelected + 1]
              ?.galleries?.galleries[0] !== undefined &&
            this.props.galleryData[this.state.galleryIndexGroupSelected + 1]
              ?.galleries?.galleries[0].length > 0
          ) {
            this.setState({
              galleryIndexFileSelected: 0,
              galleryIndexFolderSelected: 0,
              galleryIndexGroupSelected:
                this.state.galleryIndexGroupSelected + 1,
              selectedFile:
                this.props.galleryData[this.state.galleryIndexGroupSelected + 1]
                  ?.galleries?.galleries[0][0]?.links[0].link,
            });
          } else {
            this.setState({
              galleryIndexFileSelected: 0,
              galleryIndexFolderSelected: 0,
              galleryIndexGroupSelected: 0,
              selectedFile:
                this.props.galleryData[0]?.galleries?.galleries[0][0]?.links[0]
                  .link,
            });
          }
        }
      }
    }
  };

  handleBackGallery = () => {
    if (
      this.state.galleryIndexSelected !== -1 &&
      this.state.galleryIndexSelectedSub === -1
    ) {
      if (
        this.props.galleryData[this.state.galleryIndexGroupSelected]?.galleries
          ?.galleries[0][this.state.galleryIndexFolderSelected]?.links[
          this.state.galleryIndexFileSelected - 1
        ] !== undefined
      ) {
        this.setState({
          galleryIndexFileSelected: this.state.galleryIndexFileSelected - 1,
          selectedFile:
            this.props.galleryData[this.state.galleryIndexGroupSelected]
              ?.galleries?.galleries[0][this.state.galleryIndexFolderSelected]
              ?.links[this.state.galleryIndexFileSelected - 1].link,
        });
      } else {
        if (
          this.props.galleryData[this.state.galleryIndexGroupSelected]
            ?.galleries?.galleries[0][
            this.state.galleryIndexFolderSelected - 1
          ] !== undefined
        ) {
          this.setState({
            galleryIndexFileSelected:
              this.props.galleryData[this.state.galleryIndexGroupSelected]
                ?.galleries?.galleries[0][
                this.state.galleryIndexFolderSelected - 1
              ]?.links.length - 1,
            galleryIndexFolderSelected:
              this.state.galleryIndexFolderSelected - 1,
            selectedFile:
              this.props.galleryData[this.state.galleryIndexGroupSelected]
                ?.galleries?.galleries[0][
                this.state.galleryIndexFolderSelected - 1
              ]?.links[
                this.props.galleryData[this.state.galleryIndexGroupSelected]
                  ?.galleries?.galleries[0][
                  this.state.galleryIndexFolderSelected - 1
                ]?.links.length - 1
              ].link,
          });
        } else {
          this.setState({
            galleryIndexFileSelected:
              this.props.galleryData[this.state.galleryIndexSelected]?.galleries
                ?.galleries[0][
                this.props.galleryData[this.state.galleryIndexSelected]
                  ?.galleries?.galleries[0].length - 1
              ]?.links.length - 1,
            galleryIndexFolderSelected:
              this.props.galleryData[this.state.galleryIndexSelected]?.galleries
                ?.galleries[0].length - 1,
            selectedFile:
              this.props.galleryData[this.state.galleryIndexSelected]?.galleries
                ?.galleries[0][
                this.props.galleryData[this.state.galleryIndexSelected]
                  ?.galleries?.galleries[0].length - 1
              ]?.links[
                this.props.galleryData[this.state.galleryIndexSelected]
                  ?.galleries?.galleries[0][
                  this.props.galleryData[this.state.galleryIndexSelected]
                    ?.galleries?.galleries[0].length - 1
                ]?.links.length - 1
              ].link,
          });
        }
      }
    } else if (this.state.galleryIndexSelectedSub !== -1) {
      if (
        this.props.galleryData[this.state.galleryIndexGroupSelected]?.galleries
          ?.galleries[0][this.state.galleryIndexFolderSelected]?.links[
          this.state.galleryIndexFileSelected - 1
        ] !== undefined
      ) {
        this.setState({
          galleryIndexFileSelected: this.state.galleryIndexFileSelected - 1,
          selectedFile:
            this.props.galleryData[this.state.galleryIndexGroupSelected]
              ?.galleries?.galleries[0][this.state.galleryIndexFolderSelected]
              ?.links[this.state.galleryIndexFileSelected - 1].link,
        });
      } else {
        this.setState({
          galleryIndexFileSelected:
            this.props.galleryData[this.state.galleryIndexSelected]?.galleries
              ?.galleries[0][this.state.galleryIndexSelectedSub]?.links.length -
            1,
          selectedFile:
            this.props.galleryData[this.state.galleryIndexSelected]?.galleries
              ?.galleries[0][this.state.galleryIndexSelectedSub]?.links[
              this.props.galleryData[this.state.galleryIndexSelected]?.galleries
                ?.galleries[0][this.state.galleryIndexSelectedSub]?.links
                .length - 1
            ].link,
        });
      }
    } else {
      if (
        this.props.galleryData[this.state.galleryIndexGroupSelected]?.galleries
          ?.galleries[0][this.state.galleryIndexFolderSelected]?.links[
          this.state.galleryIndexFileSelected - 1
        ] !== undefined
      ) {
        this.setState({
          galleryIndexFileSelected: this.state.galleryIndexFileSelected - 1,
          selectedFile:
            this.props.galleryData[this.state.galleryIndexGroupSelected]
              ?.galleries?.galleries[0][this.state.galleryIndexFolderSelected]
              ?.links[this.state.galleryIndexFileSelected - 1].link,
        });
      } else {
        if (
          this.props.galleryData[this.state.galleryIndexGroupSelected]
            ?.galleries?.galleries[0][
            this.state.galleryIndexFolderSelected - 1
          ] !== undefined
        ) {
          this.setState({
            galleryIndexFileSelected:
              this.props.galleryData[this.state.galleryIndexGroupSelected]
                ?.galleries?.galleries[0][
                this.state.galleryIndexFolderSelected - 1
              ]?.links.length - 1,
            galleryIndexFolderSelected:
              this.state.galleryIndexFolderSelected - 1,
            selectedFile:
              this.props.galleryData[this.state.galleryIndexGroupSelected]
                ?.galleries?.galleries[0][
                this.state.galleryIndexFolderSelected - 1
              ]?.links[
                this.props.galleryData[this.state.galleryIndexGroupSelected]
                  ?.galleries?.galleries[0][
                  this.state.galleryIndexFolderSelected - 1
                ]?.links.length - 1
              ].link,
          });
        } else {
          if (
            this.props.galleryData[this.state.galleryIndexGroupSelected - 1]
              ?.galleries?.galleries[0] !== undefined &&
            this.props.galleryData[this.state.galleryIndexGroupSelected - 1]
              ?.galleries?.galleries[0].length > 0
          ) {
            this.setState({
              galleryIndexFileSelected:
                this.props.galleryData[this.state.galleryIndexGroupSelected - 1]
                  ?.galleries?.galleries[0][
                  this.props.galleryData[
                    this.state.galleryIndexGroupSelected - 1
                  ]?.galleries?.galleries[0].length - 1
                ]?.links.length - 1,
              galleryIndexFolderSelected:
                this.props.galleryData[this.state.galleryIndexGroupSelected - 1]
                  ?.galleries?.galleries[0].length - 1,
              galleryIndexGroupSelected:
                this.state.galleryIndexGroupSelected - 1,
              selectedFile:
                this.props.galleryData[this.state.galleryIndexGroupSelected - 1]
                  ?.galleries?.galleries[0][
                  this.props.galleryData[
                    this.state.galleryIndexGroupSelected - 1
                  ]?.galleries?.galleries[0].length - 1
                ]?.links[
                  this.props.galleryData[
                    this.state.galleryIndexGroupSelected - 1
                  ]?.galleries?.galleries[0][
                    this.props.galleryData[
                      this.state.galleryIndexGroupSelected - 1
                    ]?.galleries?.galleries[0].length - 1
                  ]?.links.length - 1
                ].link,
            });
          } else {
            this.setState({
              galleryIndexFileSelected:
                this.props.galleryData[this.props.galleryData.length - 1]
                  ?.galleries?.galleries[0][
                  this.props.galleryData[this.props.galleryData.length - 1]
                    ?.galleries?.galleries[0].length - 1
                ]?.links.length - 1,
              galleryIndexFolderSelected:
                this.props.galleryData[this.props.galleryData.length - 1]
                  ?.galleries?.galleries[0].length - 1,
              galleryIndexGroupSelected: this.props.galleryData.length - 1,
              selectedFile:
                this.props.galleryData[this.props.galleryData.length - 1]
                  ?.galleries?.galleries[0][
                  this.props.galleryData[this.props.galleryData.length - 1]
                    ?.galleries?.galleries[0].length - 1
                ]?.links[
                  this.props.galleryData[this.props.galleryData.length - 1]
                    ?.galleries?.galleries[0][
                    this.props.galleryData[this.props.galleryData.length - 1]
                      ?.galleries?.galleries[0].length - 1
                  ]?.links.length - 1
                ].link,
            });
          }
        }
      }
    }
  };

  ////console.log(this.props.breadCrumbSelected);

  render(): React.ReactNode {
    /* //console.log(
      this.state.galleryIndexSelected,
      this.state.galleryIndexSelectedSub,
      this.state.galleryIndexFileSelected
    ); */

    return this.state.rgbaColor !== "" ? (
      <div
        className={
          this.state.show
            ? "gallery-modal-container fade-in"
            : "gallery-modal-container fade-out"
        }
      >
        <div
          className={
            this.state.isCollapsed
              ? "gallery-preview-expanded"
              : "gallery-preview-collapsed"
          }
        >
          <div className="gallery-preview-container-intro">
            {!this.state.SelectedGallery ? (
              <Grid
                container
                spacing={3}
                className={`gallery-preview-container-grid ${
                  this.state.SelectedGallery ? "hidden" : ""
                }`}
              >
                {this.state.galleryIndexSelected >= 0 &&
                this.state.galleryIndexSelectedSub === -1
                  ? this.props.galleryData[
                      this.state.galleryIndexSelected
                    ]?.galleries?.galleries?.flatMap(
                      (galleryGroup: any, ind: number) =>
                        galleryGroup?.map((fold: any, indexFold: number) =>
                          fold?.links?.map((file: any, index: number) => (
                            <Grid
                              item
                              xs={12}
                              sm={6}
                              md={4}
                              lg={3}
                              xl={2}
                              key={`${file.name}-${index}`}
                              className={`individual-gallery-grid-intro ${
                                this.state.SelectedGallery &&
                                this.state.galleryIndexGroupSelected ===
                                  this.state.galleryIndexSelected &&
                                this.state.galleryIndexFolderSelected ===
                                  indexFold &&
                                this.state.galleryIndexFileSelected === index
                                  ? "selected"
                                  : ""
                              }`}
                              onClick={() =>
                                this.setState({
                                  selectedFile: file.link,
                                  galleryIndexFileSelected: index,
                                  galleryIndexGroupSelected:
                                    this.state.galleryIndexSelected,
                                  galleryIndexFolderSelected: indexFold,
                                  SelectedGallery: true,
                                })
                              }
                            >
                              <Item className="individual-gallery-item-intro">
                                <div className="individual-gallery-image-intro">
                                  <div>{fold?.name}</div>
                                  {fold?.name !== "Recorridos" &&
                                  fold?.name !== "Videos" && fold?.name !== "Brochures" ? (
                                    <img
                                      src={`${
                                        window.hybrid
                                          ? ""
                                          : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/"
                                      }${file.link}`}
                                      alt={file.name}
                                    />
                                  ) : fold?.name === "Brochures" ? (
                                    <img
                                      src={`https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/icons/general/Thumbnail_Brochure.webp`}
                                      alt={file.name}
                                    />
                                  ) : (
                                    <iframe
                                      src={file.link}
                                      title="virtual-tours"
                                      width={"100%"}
                                      height="100%"
                                      style={{
                                        borderRadius: ".5rem",
                                        border: "none",
                                        pointerEvents: "none",
                                      }}
                                    />
                                  )}
                                  {/* <div className="overlay"></div> */}
                                </div>
                              </Item>
                            </Grid>
                          ))
                        )
                    )
                  : this.state.galleryIndexSelectedSub >= 0
                  ? this.props.galleryData[
                      this.state.galleryIndexSelected
                    ]?.galleries?.galleries[0][
                      this.state.galleryIndexSelectedSub
                    ]?.links?.map((file: any, index: number) => (
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        md={4}
                        lg={3}
                        xl={2}
                        key={`${file.name}-${index}`}
                        className={`individual-gallery-grid-intro ${
                          this.state.SelectedGallery &&
                          this.state.galleryIndexGroupSelected ===
                            this.state.galleryIndexSelected &&
                          this.state.galleryIndexFolderSelected ===
                            this.state.galleryIndexSelectedSub &&
                          this.state.galleryIndexFileSelected === index
                            ? "selected"
                            : ""
                        }`}
                        onClick={() =>
                          this.setState({
                            selectedFile: file.link,
                            galleryIndexFileSelected: index,
                            galleryIndexGroupSelected:
                              this.state.galleryIndexSelected,
                            galleryIndexFolderSelected:
                              this.state.galleryIndexSelectedSub,
                            SelectedGallery: true,
                          })
                        }
                      >
                        <Item className="individual-gallery-item-intro">
                          <div className="individual-gallery-image-intro">
                            <div>
                              {
                                this.props.galleryData[
                                  this.state.galleryIndexSelected
                                ]?.galleries?.galleries[0][
                                  this.state.galleryIndexSelectedSub
                                ]?.name
                              }
                            </div>
                            {this.props.galleryData[
                              this.state.galleryIndexSelected
                            ]?.galleries?.galleries[0][
                              this.state.galleryIndexSelectedSub
                            ]?.name !== "Recorridos" &&
                            this.props.galleryData[
                              this.state.galleryIndexSelected
                            ]?.galleries?.galleries[0][
                              this.state.galleryIndexSelectedSub
                            ]?.name !== "Videos" && this.props.galleryData[
                              this.state.galleryIndexSelected
                            ]?.galleries?.galleries[0][
                              this.state.galleryIndexSelectedSub
                            ]?.name !== "Brochures" ? (
                              <img
                                src={`${
                                  window.hybrid
                                    ? ""
                                    : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/"
                                }${file.link}`}
                                alt={file.name}
                              />
                            ) : this.props.galleryData[
                              this.state.galleryIndexSelected
                            ]?.galleries?.galleries[0][
                              this.state.galleryIndexSelectedSub
                            ]?.name === "Brochures" ? (
                              <img
                                src={`https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/icons/general/Thumbnail_Brochure.webp`}
                                alt={file.name}
                              />
                            ) : (
                              <iframe
                                src={file.link}
                                title="virtual-tours"
                                width={"100%"}
                                height="100%"
                                style={{
                                  borderRadius: ".5rem",
                                  border: "none",
                                  pointerEvents: "none",
                                }}
                              />
                            )}
                            {/* <div className="overlay"></div> */}
                          </div>
                        </Item>
                      </Grid>
                    ))
                  : this.state.galleryIndexSelected === -1 &&
                    this.state.galleryIndexSelectedSub === -1
                  ? this.props.galleryData?.map(
                      (primaryFolder: any, pfIndex: number) =>
                        primaryFolder?.galleries?.galleries?.flatMap(
                          (galleryGroup: any, ind: number) =>
                            galleryGroup?.map((fold: any, indexFold: number) =>
                              fold?.links?.map((file: any, index: number) => (
                                <Grid
                                  item
                                  xs={12}
                                  sm={6}
                                  md={4}
                                  lg={3}
                                  xl={2}
                                  key={`${file.name}-${index}`}
                                  className={`individual-gallery-grid-intro ${
                                    this.state.SelectedGallery &&
                                    this.state.galleryIndexGroupSelected ===
                                      pfIndex &&
                                    this.state.galleryIndexFolderSelected ===
                                      indexFold &&
                                    this.state.galleryIndexFileSelected ===
                                      index
                                      ? "selected"
                                      : ""
                                  }`}
                                  onClick={() =>
                                    this.setState({
                                      selectedFile: file.link,
                                      galleryIndexFileSelected: index,
                                      galleryIndexGroupSelected: pfIndex,
                                      galleryIndexFolderSelected: indexFold,
                                      SelectedGallery: true,
                                    })
                                  }
                                >
                                  <Item className="individual-gallery-item-intro">
                                    <div className="individual-gallery-image-intro">
                                      <div>{fold?.name}</div>
                                      {fold?.name !== "Recorridos" &&
                                      fold?.name !== "Videos" && fold?.name !== "Brochures" ? (
                                        <img
                                          src={`${
                                            window.hybrid
                                              ? ""
                                              : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/"
                                          }${file.link}`}
                                          alt={file.name}
                                        />
                                      ) : fold?.name === "Brochures" ? (
                                        <img
                                          src={`https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/icons/general/Thumbnail_Brochure.webp`}
                                          alt={file.name}
                                        />
                                      ) : (
                                        <iframe
                                          src={file.link}
                                          title="virtual-tours"
                                          width={"100%"}
                                          height="100%"
                                          style={{
                                            borderRadius: ".5rem",
                                            border: "none",
                                            pointerEvents: "none",
                                          }}
                                        />
                                      )}
                                      {/* <div className="overlay"></div> */}
                                    </div>
                                  </Item>
                                </Grid>
                              ))
                            )
                        )
                    )
                  : null}
              </Grid>
            ) : (
              <>
                <div
                  className={`only-gallery-selected-container ${
                    !this.state.SelectedGallery ? "closing" : "visibility"
                  }`}
                >
                  {this.props.galleryData[this.state.galleryIndexGroupSelected]
                    ?.galleries?.galleries[0][
                    this.state.galleryIndexFolderSelected
                  ]?.name !== "Recorridos" &&
                  this.props.galleryData[this.state.galleryIndexGroupSelected]
                    ?.galleries?.galleries[0][
                    this.state.galleryIndexFolderSelected
                  ]?.name !== "Videos" &&
                  this.props.galleryData[this.state.galleryIndexGroupSelected]
                    ?.galleries?.galleries[0][
                    this.state.galleryIndexFolderSelected
                  ]?.name !== "Fotos 360°" &&
                  this.props.galleryData[this.state.galleryIndexGroupSelected]
                    ?.galleries?.galleries[0][
                    this.state.galleryIndexFolderSelected
                  ]?.name !== "Brochures" ? (
                    <img
                      src={`${
                        window.hybrid
                          ? ""
                          : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/"
                      }${this.state.selectedFile}`}
                      alt=""
                    />
                  ) : 
                  this.props.galleryData[this.state.galleryIndexGroupSelected]
                    ?.galleries?.galleries[0][
                    this.state.galleryIndexFolderSelected
                  ]?.name === "Brochures" ? (
                    <iframe
                      src={this.state.selectedFile}
                      title="virtual-tours"
                      width={"100%"}
                      height="100%"
                      style={{
                        borderRadius: ".5rem",
                        border: "none",
                      }}
                    />
                  ) : this.props.galleryData[
                      this.state.galleryIndexGroupSelected
                    ]?.galleries?.galleries[0][
                      this.state.galleryIndexFolderSelected
                    ]?.name === "Fotos 360°" ? (
                    <ThreeScene
                      selectedFile={`${
                        window.hybrid
                          ? ""
                          : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/"
                      }${encodeURIComponent(this.state.selectedFile)}`}
                    />
                  ) : (
                    <iframe
                      src={this.state.selectedFile}
                      title="virtual-tours"
                      width={"100%"}
                      height="100%"
                      style={{
                        borderRadius: ".5rem",
                        border: "none",
                      }}
                    />
                  )}
                </div>
                <div className="only-gallery-selected-container-opciones">
                  <div className="only-gallery-selected-container-opciones-descripcion">
                    <div>
                      {
                        this.props.galleryData[
                          this.state.galleryIndexGroupSelected
                        ]?.galleries?.galleries[0][
                          this.state.galleryIndexFolderSelected
                        ]?.links[
                          this.state.galleryIndexFileSelected
                        ].name.split(".")[0]
                      }
                    </div>
                    <div style={{ color: "#434343", fontSize: "0.7rem" }}>
                      {
                        this.props.galleryData[
                          this.state.galleryIndexGroupSelected
                        ]?.galleries?.galleries[0][
                          this.state.galleryIndexFolderSelected
                        ]?.name
                      }
                    </div>
                  </div>
                  <div className="only-gallery-selected-container-opciones-next-back">
                    <div onClick={() => this.handleBackGallery()}>
                      <img src={back_b} alt="" sizes="" />
                    </div>
                    <span> </span>
                    <div onClick={() => this.handleNextGallery()}>
                      <img src={next_b} alt="" sizes="" />
                    </div>
                  </div>
                  <div
                    className="only-gallery-selected-container-opciones-return"
                    style={{
                      backgroundColor: this.props.colorsData.main_buttons,
                      color: this.props.colorsData.secondary_text,
                      borderColor: this.props.colorsData.main_buttons,
                    }}
                    onClick={() =>
                      this.setState({
                        SelectedGallery: false,
                      })
                    }
                  >
                    <div>Cerrar</div>
                  </div>
                </div>
              </>
            )}
          </div>

          {/* <div className="gallery-preview-image-container">
                        <img src={gallery} alt="" className="gallery-preview-image"/>
                        <div className="gallery-preview-text">
                            Selecciona una opción en el panel para navegar en la galería
                        </div>
                    </div> */}
        </div>
        <div
          className={
            this.state.isCollapsed
              ? "gallery-media-container-wide"
              : "gallery-media-container"
          }
        >
          <div className="gallery-media-container-close"></div>
        </div>
        {
          <div
            className={
              this.state.isCollapsed
                ? "collapsed-general-gallery-btn-collapsed"
                : "collapsed-general-gallery-btn"
            }
            onClick={() => {
              this.setState({ isCollapsed: !this.state.isCollapsed });
            }}
          >
            <img src={collapsed} alt="" />
          </div>
        }
        {this.props.isGallery ? (
          <div
            className={
              this.state.isCollapsed
                ? "gallery-general-sidebar-collapsed"
                : "gallery-general-sidebar"
            }
          >
            <div
              className="general-gallery-close-container"
              onClick={() => {
                this.setState({
                  galleryIndexSelected: -1,
                  galleryItemSelected: "",
                  breadCrumbs: [],
                  isCollapsed: true,
                  SelectedGallery: false,
                });
                setTimeout(() => {
                  this.setState(
                    {
                      show: false,
                    },
                    () => {
                      setTimeout(() => {
                        this.props.handleCloseGalleryModal();
                      }, 500);
                    }
                  );
                }, 500);
              }}
            >
              <img src={close} alt="" />
            </div>
            <div className="general-gallery-img-icon-container">
              <img src={gallery} alt="" />
            </div>
            <div
              className="galerry-name-desktop"
              onClick={() => {
                this.setState({
                  galleryIndexSelected: -1,
                  galleryIndexSelectedSub: -1,
                  galleryItemSelected: "",
                  breadCrumbs: ["Galería"],
                  SelectedGallery: false,
                });
              }}
            >
              GALERÍA
            </div>
            {this.state.galleryIndexSelected !== -1 ||
            this.state.galleryIndexSelectedSub !== -1 ? (
              <div className="breadcrumbs-gallery-container-desktop">
                {this.state.galleryItemSelected !== "" ? (
                  <div
                    style={{ display: "flex" }}
                    className="bread-crumbs-individual-container"
                  >
                    <div
                      className="deselected-bread-crumb-individual"
                      onClick={() => {
                        this.setState({
                          galleryIndexSelected: -1,
                          galleryIndexSelectedSub: -1,
                          galleryItemSelected: "",
                          breadCrumbs: ["Galería"],
                          SelectedGallery: false,
                        });
                      }}
                    >
                      {"Galería"}
                    </div>
                    <img src={next} alt="" />
                    <div
                      className="selected-breadcrumb-individual"
                      style={{
                        backgroundColor: this.props.colorsData.main_buttons,
                      }}
                      onClick={() =>
                        this.setState({
                          galleryIndexSelectedSub: -1,
                          SelectedGallery: false,
                        })
                      }
                    >
                      {this.state.galleryItemSelected}
                    </div>
                  </div>
                ) : null}
              </div> /* : this.state.galleryIndexSelected !== -1 &&
              this.state.galleryIndexSelectedSub !== -1 ? (
              <div className="breadcrumbs-gallery-container-desktop">
                {this.state.galleryItemSelected !== "" ? (
                  <div
                    style={{ display: "flex" }}
                    className="bread-crumbs-individual-container"
                  >
                    <div
                      className="deselected-bread-crumb-individual"
                      onClick={() => {
                        this.setState({
                          galleryIndexSelected: -1,
                          galleryIndexSelectedSub: -1,
                          galleryItemSelected: "",
                          breadCrumbs: ["Galería"],
                        });
                      }}
                    >
                      {"Galería"}
                    </div>
                    <img src={next} alt="" />

                    <div
                      className="deselected-bread-crumb-individual"
                      onClick={() => {
                        this.setState({
                          galleryIndexSelectedSub: -1,
                          breadCrumbs: [
                            this.props.galleryData[
                              this.state.galleryIndexSelected
                            ]?.galleries?.galleries[0][
                              this.state.galleryIndexSelectedSub
                            ]?.name,
                          ],
                        });
                      }}
                    >
                      {
                        this.props.galleryData[this.state.galleryIndexSelected]
                          ?.galleries?.galleries[0][
                          this.state.galleryIndexSelectedSub
                        ]?.name
                      }
                    </div>
                    <img src={next} alt="" />
                    <div
                      className="selected-breadcrumb-individual"
                      style={{
                        backgroundColor: this.props.colorsData.main_buttons,
                      }}
                      onClick={() =>
                        this.setState({
                          galleryIndexSelectedSub: -1,
                        })
                      }
                    >
                      {this.state.galleryItemSelected}
                    </div>
                  </div>
                ) : null}
              </div>
            )  */
            ) : null}
            <div className="gallery-categories-container">
              {this.state.galleryIndexSelected === -1
                ? this.props.galleryData.map(
                    (galleryCategory: any, index: number) =>
                      galleryCategory.galleries.galleries.length > 0 ? (
                        <div
                          className="individual-gallery-container"
                          onClick={() => {
                            this.setState({
                              galleryItemSelected: galleryCategory.name,
                              galleryIndexSelected: index,
                              galleryIndexSelectedSub: -1,
                              SelectedGallery: false,
                            });
                            this.props.handleChangeBreadCrumbSelected(0);
                          }}
                          style={{
                            pointerEvents: this.state.isCollapsed
                              ? "none"
                              : "all",
                            animation:
                              "fadein " + (index + 1.2) + "s ease-in-out 1",
                          }}
                        >
                          <div className="indiividual-gallery-image">
                            <img
                              src={
                                (window.hybrid
                                  ? ""
                                  : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/") +
                                galleryCategory.background
                              }
                              alt=""
                            />
                          </div>
                          <div className="indiividual-gallery-image-desc">
                            {galleryCategory.name.toUpperCase()}
                          </div>
                          {/* <div
                            className="individual-gallery-name"
                            style={{
                              backgroundColor: `rgba(${this.state.rgbaColor.r},${this.state.rgbaColor.g},${this.state.rgbaColor.b}, 0.8)`,
                            }}
                          >
                            <div>{galleryCategory.name.toUpperCase()}</div>
                          </div> */}
                        </div>
                      ) : null
                  )
                : null}
            </div>
            {this.state.galleryIndexSelected !== -1 ? (
              <div className="gallerie-modal-items-container">
                {this.props.galleryData[
                  this.state.galleryIndexSelected
                ].galleries.galleries.map((galleries: any, index: number) =>
                  galleries.map((gallery: any, gIndex: number) => (
                    <div
                      className="gallerie-modal-items-individual"
                      style={
                        this.state.galleryIndexSelectedSub === gIndex
                          ? {
                              backgroundColor:
                                this.props.colorsData.main_buttons,
                              color: this.props.colorsData.secondary_text,
                              borderColor: this.props.colorsData.main_buttons,
                            }
                          : {}
                      }
                      onClick={() => {
                        this.setState(
                          {
                            breadCrumbs: [],
                            galleryIndexSelectedSub: gIndex,
                            SelectedGallery: false,
                          },
                          () => {
                            this.state.breadCrumbs.push(
                              this.state.galleryItemSelected
                            );
                            this.state.breadCrumbs.push(gallery.name);
                            /* this.props.handleGalleriesSelection(
                              gallery,
                              this.state.breadCrumbs,
                              true
                            ); */
                          }
                        );
                      }}
                    >
                      <img
                        src={gallery.icon}
                        style={
                          this.state.galleryIndexSelectedSub === gIndex
                            ? { filter: "invert(1) brightness(200%)" }
                            : {}
                        }
                        alt=""
                      />
                      <div className="gallerie-modal-name">{gallery.name}</div>
                    </div>
                  ))
                )}
              </div>
            ) : null}
          </div>
        ) : null}
      </div>
    ) : null;
  }
}

export default GalleryModal;
